/**
 * Card / UI images for Explore Unknown minigame win-reward ids.
 * Aligned with battle bonus units and HUD meters (`/images/...`).
 */
export const EXPLORE_UNKNOWN_MINIGAME_WIN_REWARD_IMAGES = Object.freeze({
  darknessReduction5: '/images/sad.jpg',
  darknessReduction10: '/images/embarrassing.jpg',
  darknessReduction20: '/images/happy.jpg',
  extraXp300: '/minigames/xp.png',
  extraXp600: '/minigames/xp.png',
  extraXp1200: '/minigames/xp.png',
  extraXp2000: '/minigames/xp.png',
  extraXp4000: '/minigames/xp.png',
  extraXp5000: '/minigames/xp.png',
  extraXp4500: '/minigames/xp.png',
  extraXp6000: '/minigames/xp.png',
  extraXp5500: '/minigames/xp.png',
  darkKnowledgeFragment: '/images/dark_knowledge.jpg',
  weakHeartFragment: '/images/weak_heart.jpg',
  heartFragment: '/images/heart.jpg',
  strongHeartFragment: '/images/strong_heart.jpg',
  epTargetFragment: '/images/ep_single.jpg',
  epZoneFragment: '/images/ep_zone.jpg',
  epGlobalFragment: '/images/ep_board.jpg',
  startHealthPlus3: '/images/heart.jpg',
  rewriteExperienceFragment: '/images/retry.jpg',
  billyBucks: '/images/billy_bucks.png',
});

/**
 * @param {string} rewardId
 * @returns {string}
 */
export function getExploreUnknownMinigameWinRewardImageSrc(rewardId) {
  if (typeof rewardId !== 'string' || !rewardId) {
    throw new Error(`getExploreUnknownMinigameWinRewardImageSrc: invalid rewardId (${JSON.stringify(rewardId)})`);
  }
  const src = EXPLORE_UNKNOWN_MINIGAME_WIN_REWARD_IMAGES[rewardId];
  if (!src) {
    throw new Error(`getExploreUnknownMinigameWinRewardImageSrc: unknown rewardId ${JSON.stringify(rewardId)}`);
  }
  return src;
}
